<script setup>
import { ref } from 'vue';
import SummaryReportsAPI from 'dashboard/api/summaryReports';

const contacts = ref([]);
const total = ref(0);
const contactAttributeKey = ref('');
const contactAttributeValue = ref('');
const conversationAttributeKey = ref('ad_attribution.source');
const conversationAttributeValue = ref('FB_Ads');

const search = async () => {
  const { data } = await SummaryReportsAPI.getLabelContacts({
    contact_attribute_key: contactAttributeKey.value || undefined,
    contact_attribute_value: contactAttributeValue.value || undefined,
    conversation_attribute_key: conversationAttributeKey.value || undefined,
    conversation_attribute_value: conversationAttributeValue.value || undefined,
  });
  contacts.value = data.payload;
  total.value = data.meta.count;
};
</script>

<template>
  <section class="mt-5 rounded-xl border border-n-weak bg-n-solid-2 p-4">
    <div class="flex flex-wrap gap-2">
      <input
        v-model="contactAttributeKey"
        class="input"
        :placeholder="$t('LABEL_REPORTS.CONTACTS.CONTACT_ATTRIBUTE')"
      />
      <input
        v-model="contactAttributeValue"
        class="input"
        :placeholder="$t('LABEL_REPORTS.CONTACTS.VALUE')"
      />
      <input
        v-model="conversationAttributeKey"
        class="input"
        :placeholder="$t('LABEL_REPORTS.CONTACTS.CONVERSATION_ATTRIBUTE')"
      />
      <input
        v-model="conversationAttributeValue"
        class="input"
        :placeholder="$t('LABEL_REPORTS.CONTACTS.VALUE')"
      />
      <button class="btn btn-primary" @click="search">
        {{ $t('LABEL_REPORTS.CONTACTS.FILTER') }}
      </button>
    </div>
    <p class="mt-4 text-sm text-n-slate-11">
      {{ $t('LABEL_REPORTS.CONTACTS.COUNT', { count: total }) }}
    </p>
    <a
      v-for="item in contacts"
      :key="item.id"
      :href="`/app/accounts/${$route.params.accountId}/inbox/${item.inbox_id}/conversations/${item.id}`"
      class="mt-2 flex justify-between rounded-lg px-3 py-2 hover:bg-n-alpha-1"
    >
      <span>{{ item.contact.name || item.contact.phone_number }}</span>
      <span>{{ item.origin || '-' }}</span>
    </a>
  </section>
</template>
